;
define("product_views_price.tpl", function(){});

